import React, { createContext, useContext, useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getMe } from '~/controllers/users';
import { IUser } from '~/domain/IUser';

const LoggedUserContext = createContext<IUser|undefined>(undefined);

interface ILoggedUserProvider {
  children: React.ReactNode;
}

export const LoggedUserProvider: React.FC<ILoggedUserProvider> = (props) => {
  const [user, setUser] = useState<IUser>();

  const {
    data: loggedUser,
    refetch: refreshMe,
  } = useQuery(['getMe'], getMe, {
    cacheTime: 0,
    staleTime: 0,
    retry: false,
    enabled: true,
  });

  useEffect(() => {
    if (loggedUser) {
      setUser(loggedUser);
    }
  }, [refreshMe, loggedUser, setUser]);

  return (
    <LoggedUserContext.Provider value={user}>
      {props.children}
    </LoggedUserContext.Provider>
  );
}

export const useLoggedUser = () => useContext(LoggedUserContext);
